import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export const useUserGroupMembership = (groupId?: string | null) => {
  const { user } = useAuth();
  const [isUserInGroup, setIsUserInGroup] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const checkUserGroupMembership = async () => {
      if (!user?.id || !groupId) {
        setIsUserInGroup(false);
        return;
      }

      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('user_groups')
          .select('id')
          .eq('user_id', user.id)
          .eq('group_id', groupId)
          .maybeSingle();

        if (error) {
          console.error('Error checking user group membership:', error);
          setIsUserInGroup(false);
          return;
        }

        setIsUserInGroup(!!data);
      } catch (error) {
        console.error('Error checking user group membership:', error);
        setIsUserInGroup(false);
      } finally {
        setLoading(false);
      }
    };

    checkUserGroupMembership();
  }, [user?.id, groupId]);

  return {
    isUserInGroup,
    loading
  };
};